export enum QueryParams {
  sort = 'sort',
  perPage = 'perPage',
  query = 'query',
  page = 'page',
}
